import React, { useEffect, useState } from 'react';
import CommonService from '../services/CommonService';

function LocationComponent() {
    const user = JSON.parse(localStorage.getItem("user"));

    const [location, setLocation] = useState({
        latitude: null,
        longitude: null,
        error: null,
    });

    const [address, setAddress] = useState('');

    useEffect(() => {
        getLocation();
        getDir();
    }, [])

    const getLocation = () => {
        if (!navigator.geolocation) {
            setLocation({ ...location, error: 'Geolocation is not supported by your browser' });
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (position) => {
                setLocation({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                    error: null,
                });

                if (position.coords.latitude) {
                    getFullAddress(position.coords.latitude, position.coords.longitude);
                }
            },
            (err) => {
                setLocation({ ...location, error: err.message });
            }
        );
    };

    const getFullAddress = async (lat, lng) => {

        const response = await CommonService.getAddressFromLatLng(lat, lng);
        const data = response?.data; // ApiResponse.data
        // console.log(result);
        if (data.status === 'OK') {
            const faddress = data.results[0].formatted_address;
            setAddress(faddress);
            saveLocation(lat, lng, faddress);
        } else {
            console.error('Geocoding error:', data.status);
            return null;
        }
    };

    const saveLocation = async (lat, lng, address) => {

        let params = {
            uId: Number(user.uId),
            location: address,
            lat: lat,
            lng: lng,
        };

        try {
            if (lat) {
                await CommonService.saveStartLatLng(params);
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    }

    const getDir = async () => {
        const data = await CommonService.getDirections();
        // console.log(data);
        // console.log('Route Summary:', data.routes[0].summary);
        // console.log('Estimated Time (with traffic):', data.routes[0].legs[0].duration.text);
        // console.log('Estimated Time (with traffic):', data.routes[0].legs[0].duration_in_traffic.text);

    };

    return (
        <div className="p-4">
            <button
                onClick={getLocation}
                className="btn btn-sm btn-success text-white px-4 py-2 rounded"
            >
                Get Location
            </button>

            {location.latitude && location.longitude && (
                <div className="mt-4">
                    <p>Latitude: {location.latitude}</p>
                    <p>Longitude: {location.longitude}</p>
                </div>
            )}

            {address && (
                <p className="mt-4 text-red-500">Address: {address}</p>
            )}

            {location.error && (
                <p className="mt-4 text-red-500">Error: {location.error}</p>
            )}
        </div>
    );
}

export default LocationComponent;
